<template>
    <div :class="['menuScreen',isActive ? 'active':'']" id="menuScreen1">
        <audio class="audioPlayer1" id="sfx1" src="sfx/click1.mp3"></audio>        
<!--<div class="trigger" @click="triggerFx">
            <span>fx:{{itemModeClass}}</span>
        </div>-->

        <div class="menuElements">

            <ul __class="row">
                <!-- sections.slice(0,3) -->
                <li :class="[itemModeClass]" __class="item" @click="openItem(index)" v-for="(item,index) in sections" :key="index">
                    <!-- {{item.menu_logo}} -->
                    <div :class="[itemModeClass]" @click="openItem(index)">
                        <div class="menuItem">
                            <img :style="getIndexVar(index)" src="images/ui/cir1.png" :class="['menuCirElement','mc1']">
                            <img :style="getIndexVar(index)" src="images/ui/cir2.png" :class="['menuCirElement','mc2']">
                            <img :style="getIndexVar(index)" src="images/ui/cir3.png" :class="['menuCirElement','mc3']">
                            <img :style="getIndexVar(index)" src="images/ui/cir4.png" :class="['menuCirElement','mc4']">                        
                            <img  ___style="getIndexVar(index)" :style="getIconSize(item)+getIndexVar(index)" :src="item.menu_logo" class="menuLogo">
                        </div>
                    </div>                    
                </li>                
            </ul>
            <!--<ul __class="row">
                <li :class="[itemModeClass]" __class="item" @click="openItem(index)" v-for="(item,index) in sections.slice(3,5)" :key="index">
                    <div :class="[itemModeClass]" @click="openItem(index+3)">
                        <div class="menuItem">
                            <img :style="getIndexVar(index)" src="images/ui/cir1.png" :class="['menuCirElement','mc1']">
                            <img :style="getIndexVar(index)" src="images/ui/cir2.png" :class="['menuCirElement','mc2']">
                            <img :style="getIndexVar(index)" src="images/ui/cir3.png" :class="['menuCirElement','mc3']">
                            <img :style="getIndexVar(index)" src="images/ui/cir4.png" :class="['menuCirElement','mc4']">                        
                            <img  ___style="getIndexVar(index)" :style="getIconSize(item)+getIndexVar(index)" :src="item.menu_logo" class="menuLogo">
                        </div>
                    </div>                    
                </li>                
            </ul>-->
        </div>

        <!-- <img src="images/menu/_logoCircle.png" :class="['menuCir']"> -->
        <!--
        <div class="menuElements" >
            <ul>                
                <li
                    :class="[itemModeClass]"
                    @click="openItem(index)" v-for="(item,index) in sections" :key="index">
                    <div class="menuItem">
                        <img :style="getIndexVar(index)" src="images/ui/cir1.png" :class="['menuCirElement','mc1']">
                        <img :style="getIndexVar(index)" src="images/ui/cir2.png" :class="['menuCirElement','mc2']">
                        <img :style="getIndexVar(index)" src="images/ui/cir3.png" :class="['menuCirElement','mc3']">
                        <img :style="getIndexVar(index)" src="images/ui/cir4.png" :class="['menuCirElement','mc4']">                        
                            <img 
                            ___style="getIndexVar(index)"
                            :style="getIconSize(item)+getIndexVar(index)"
                            :src="item.menu_logo" class="menuLogo">                                            
                    </div>
                </li>
            </ul>
        </div>            
        -->


  </div>
</template>

<style scoped>

        .container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100vh;
        }

        /* Row styling */
        .row {
            display: flex;
            justify-content: center;
            margin: 10px 0;
        }
        .item {
            width: 20vw;
            height: 20vw;
            margin: 0 10px;
            background-color: #4CAF50;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: bold;
            font-size: 20px;
        }

    .audioPlayer1
    {
        display: none;
    }
    .menuScreen
    {
        width: 100vw;
        height: 100vh;
        display: flex;
        align-content: center;
        align-items: center;
        opacity: 0;
        transition: all ease 0.2s;
    }
    .menuScreen.active
    {
        opacity: 1;
    }
    .menuScreen .menuElements
    {
        color: #fff;
        margin: auto;
        text-align: center;
    }
    .menuScreen .menuElements ul
    {
        margin: auto;
        list-style: none;
        display: flex;
        gap: 6px;
        padding: 0px;   
        width: auto;
        margin: auto;
        justify-content: center;

    }
    .menuScreen .menuElements ul li
    {
        background-color: transparent;
        padding: 6px;
    }
    .menuItem
    {
        width: 31vh;
        height: 31vh;
        position: relative;
    }
    .menuCir
    {
        width: 31vh;
        height: auto;        
        position: absolute;
        top:0px;left: 0px;
    }
    .menuCirElement
    {
        width: 31vh;
        height: auto;        
        position: absolute;
        top:0px;left: 0px;
    }



    /* xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx */
    :root
    {
        --menuFxDelay:2s;
    }
    .menuCirElement.mc1
    {
        opacity: 1;
        transform: scale(0.1);
        transition: all 1.4s cubic-bezier(0.51, 0, 0.1, 1.4);
        /* transition-delay: calc(0.1s + (var(--index) * var(--menuFxDelay)));  */
        transition-delay: calc(0.1s + (var(--index) * 0.2s));
    }
    .menuCirElement.mc2
    {
        opacity: 0;
        transform: scale(0.1);
        transition: all 1.4s cubic-bezier(0.51, 0, 0.1, 1);
        transition-delay: calc(0.2s + (var(--index) * 0.2s));
    }
    .menuCirElement.mc3
    {
        opacity: 0;
        transform: scale(0.1);
        transition: all 2s cubic-bezier(0.51, 0, 0.1, 1);
        transition-delay: calc(0.4s + (var(--index) * 0.2s));
    }
    .menuCirElement.mc4
    {
        opacity: 0;
        transform: scale(0.1);
        transition: all 1.7s cubic-bezier(0.51, 0, 0.1, 1);
        transition-delay: calc(0.5s + (var(--index) * 0.2s));
    }
    .menuElements ul li .menuLogo
    {
        width: auto;
        height: 7vh;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%) scale(0.7);        
        opacity: 0;        
        transition: all ease-in 0.6s;
        transition-delay: calc(1.3s + (var(--index) * 0.2s));
    }


    /* xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx */
    .menuScreen .menuElements ul li.openFx .menuCirElement.mc1
    {
        transform: scale(1);
        opacity: 0.4;
    }
    .menuScreen .menuElements ul li.openFx .menuCirElement.mc2
    {
        opacity: 1;
        transform: scale(1);
    }
    .menuScreen .menuElements ul li.openFx .menuCirElement.mc3
    {
        opacity: 1;
        transform: scale(1);
    }
    .menuScreen .menuElements ul li.openFx .menuCirElement.mc4
    {
        opacity: 1;
        transform: scale(1);
    }
    .menuElements ul li.openFx .menuLogo
    {
        opacity: 1;
    }

    /* closeFx xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx */
    .menuScreen .menuElements ul li.closeFx .menuCirElement.mc1
    {
        transition-delay: 0s !important;
        transition-duration: 0.4s;
        transform: scale(0.4);opacity: 0;
    }
    .menuScreen .menuElements ul li.closeFx .menuCirElement.mc2
    {
        transition-delay: 0s !important;
        transition-duration: 0.4s;
        transform: scale(0.4);opacity: 0;
    }
    .menuScreen .menuElements ul li.closeFx .menuCirElement.mc3
    {
        transition-delay: 0s !important;
        transition-duration: 0.4s;
        transform: scale(0.4);opacity: 0;
    }
    .menuScreen .menuElements ul li.closeFx .menuCirElement.mc4
    {
        transition-delay: 0s !important;
        transition-duration: 0.4s;
        transform: scale(0.4);opacity: 0;
    }
    .menuElements ul li.closeFx .menuLogo
    {
        transition-delay: 0s !important;
        transition-duration: 0.4s;
        opacity: 0;
    }    
    .menuScreen .menuElements ul li span
    {
        margin: auto;
    }
    .menuScreen .menuElements ul li .menuCir
    {
        transition: all ease 0.4s;
    }
    .menuScreen .menuElements ul li.closing .menuLogo
    {
        opacity: 0;
    }
    .menuScreen .menuElements ul li.closing .menuCir
    {
        transform: scale(0.7);
        opacity: 0;
    }
    .trigger
    {
        position: fixed;
        top: 0px;
        left: 0px;
        z-index: 10000;
        width: 200px;height: 50px;background-color: #000;
        cursor: pointer;color: #fff;font-size: 11px;
        text-align: center;
        display: flex;
        align-items: center;
    }
    .trigger span
    {
        margin: auto;
    }

    /* CSS rules for tablets in portrait mode */
    @media only screen and (min-device-width: 601px) 
            and (max-device-width: 1024px) 
            and (orientation: portrait) 
    {
        
        .menuScreen .menuElements ul
        {
            display: grid;
            gap: 0px;
            padding: 0px;
            width: 90vw;
            margin: auto;
            flex-direction: row;
            grid-template-columns: 50% 50%;            
        }        
        .menuScreen .menuElements ul li
        {
            padding: 0px;
            width: 45vw;
        }
        .menuItem
        {
            width: 45vw;
            height: 45vw;
        }
        .menuCirElement
        {
            width: 45vw;
            height: auto;            
        }
    }

    /* CSS rules for smartphones in portrait mode */
    @media only screen and (max-device-width: 800px) and (orientation: portrait) 
    {
        .menuScreen .menuElements ul
        {
            display: grid;
            gap: 5px;
            grid-template-columns: 50% 50%;
        }
        .menuScreen .menuElements ul li{
            padding: 0px;
        }        
        .menuItem
        {
            width: 20vh;
            height: 20vh;
        }
        .menuElements ul li .menuLogo
        {
            height: 4vh;
        }
        .menuCirElement
        {
            width: 20vh;
        }

    }

</style>

<script>
    import { mapState, mapGetters, mapActions } from "vuex";
    //import Screen from "@/components/Screen.vue";
    export default 
    {
        computed:
        {
            ...mapState(["appData"]),
            sectionsFirstRow()
            {
                return this.sections.slice(0,3);
            }
        },
        data()
        {
            return {
                isOpenFx:false,
                isActive:false,
                sections:[],
                itemModeClass:''//closing
            }
        },
        mounted()
        {
            var vm = this;
            this.sections = this.appData.SECTIONS;
            setTimeout(() => {                
                this.isActive=true;
            }, 300);            

            setTimeout(() => {
                this.itemModeClass = 'openFx'; //open circles fx                
            }, 450);

            setTimeout(() => {
                //this.sfxPlay("icons_for_menu");
            }, 900);

            window.onresize = function() {
                vm.setScreenHeight();
            };
            vm.setScreenHeight();
        },
        created()
        {
            this.setScreenHeight();
        },
        methods:
        {       
            getIconSize(item)
            {
                if(item.name=='lynx')
                {
                    return "height: 5.7vh;";//6/7
                }
                return "height: 7vh;";//6/7
            },
            setScreenHeight()
            {
                if(window.innerWidth<1000)
                {
                    let menuScreen1 = document.getElementById("menuScreen1");
                    menuScreen1.style.height = window.innerHeight + "px";
                }
            },
            getIndexVar(index)
            {
                return '--index:'+index;
            },
            triggerFx()
            {
                if(this.itemModeClass != 'openFx')
                {
                    this.itemModeClass = 'openFx';
                }else{
                    this.itemModeClass = '';
                }                
            },  
            openItem(index)
            {
                this.sfxPlay("Interface_3");
                this.itemModeClass = 'closeFx';
                setTimeout(() => {
                    this.isActive = false;
                    this.$emit('onClick',index);
                }, 500);                
                
            }
        }
    };
</script>